import { render, staticRenderFns } from "./NewTaskElement.vue?vue&type=template&id=57eb89ac&scoped=true"
import script from "./NewTaskElement.vue?vue&type=script&lang=js"
export * from "./NewTaskElement.vue?vue&type=script&lang=js"
import style0 from "./NewTaskElement.vue?vue&type=style&index=0&id=57eb89ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb89ac",
  null
  
)

export default component.exports